var _defs, _defs2, _defs3, _defs4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M57.123,297.862c0,0,7.075,61.73,59.535,88.101c52.46,26.37,103.847,0.715,151.022-5.465 c24.705-3.237,47.614,8.91,71.838,11.454c77.455,8.131,138.239-83.144,127.336-150.286 c-9.439-58.125-46.581-99.15-114.261-128.421c-67.68-29.271-114.233-52.562-192.846-25.036 C81.133,115.734,51.518,217.937,57.123,297.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M57.123,297.862c0,0,7.075,61.73,59.535,88.101 c52.46,26.37,103.847,0.715,151.022-5.465c24.705-3.237,47.614,8.91,71.838,11.454c77.455,8.131,138.239-83.144,127.336-150.286 c-9.439-58.125-46.581-99.15-114.261-128.421c-67.68-29.271-114.233-52.562-192.846-25.036 C81.133,115.734,51.518,217.937,57.123,297.862z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clock"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9904 -0.1379 0.1379 0.9904 -21.7232 38.2042)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 264.912,
    cy: 175.909,
    rx: 44.085,
    ry: 44.085
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9822 -0.1879 0.1879 0.9822 -28.3304 52.8998)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 264.912,
    cy: 175.909,
    rx: 36.531,
    ry: 36.531
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 241.61,175.909 264.912,175.909 264.912,209.529  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M98.649,152.47c0,0,0-5.911-8.276-14.187c-8.276-8.276-13.596-13.005-13.596-13.005 s-4.138,13.596,3.547,21.872c7.685,8.276,18.325,15.961,18.325,15.961V152.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M86.638,189.388c0,0,0-5.911-8.276-14.187c-8.276-8.276-13.596-13.005-13.596-13.005 s-4.138,13.596,3.547,21.872c7.685,8.276,18.325,15.961,18.325,15.961V189.388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M98.129,162.538c0,0,0.625-5.878,9.729-13.233c9.104-7.355,14.894-11.495,14.894-11.495 s2.678,13.957-5.838,21.375c-8.516,7.418-19.909,13.935-19.909,13.935L98.129,162.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M83.619,206.138c0,0,1.239-5.78,11.065-12.138c9.826-6.358,16.019-9.868,16.019-9.868 s1.197,14.161-8.051,20.644c-9.248,6.482-21.263,11.766-21.263,11.766L83.619,206.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M86.347,253.674c0,0,0-5.911,8.276-14.188c8.276-8.276,13.596-13.005,13.596-13.005 s4.138,13.596-3.547,21.872c-7.684,8.276-18.325,15.961-18.325,15.961V253.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M86.209,265.277c0,0,0.84-5.852-6.176-15.22c-7.016-9.368-11.61-14.805-11.61-14.805 s-6.028,12.87,0.403,22.154c6.431,9.284,15.871,18.403,15.871,18.403L86.209,265.277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M78.048,299.663c0,0,0-5.911,8.276-14.187C94.6,277.2,99.92,272.471,99.92,272.471 s4.138,13.596-3.547,21.872c-7.685,8.276-18.325,15.961-18.325,15.961V299.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M83.575,330.84c0,0-1.497-5.718,4.413-15.821c5.91-10.102,9.859-16.025,9.859-16.025 s7.446,12.105,2.108,22.057c-5.338,9.952-13.685,20.082-13.685,20.082L83.575,330.84z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M99.399,150.955c-0.484,6.319-1.202,12.856-2.267,18.355c-3.272,16.902-11.45,27.807-14.722,43.074 c-3.272,15.267,6.12,34.935,3.605,54.544c-2.515,19.609-10.148,30.514-7.967,43.599c2.181,13.086,13.631,48.526,13.631,48.526"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 98.047,
    y1: 166.467,
    x2: 106.966,
    y2: 159.623
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 98.463,
    y1: 158.585,
    x2: 94.729,
    y2: 151.948
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M82.906,211.682c0,0,7.467-5.6,15.141-11.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M86.638,200.028c0,0-6.221-12.198-13.273-20.287"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M86.64,262.083c0,0,5.808-11.408,15.97-21.363"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M85.188,270.38c0,0-3.734-8.919-8.089-15.348c-4.356-6.43-4.978-7.259-4.978-7.259"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M78.049,310.527c0,0,2.991-7.584,6.724-13.599c3.733-6.015,8.711-11.408,8.711-11.408"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M86.27,341.133c0,0-0.874-7.079,2.237-13.094c3.111-6.015,6.637-13.896,8.089-17.007"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M44.456,231.442c0,0-0.642-3.707,3.65-9.795c4.291-6.088,7.114-9.631,7.114-9.631 s4.071,8.077,0.15,14.101s-9.759,11.998-9.759,11.998L44.456,231.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M55.995,253.289c0,0-0.642-3.707,3.649-9.795c4.291-6.088,7.114-9.631,7.114-9.631 s4.071,8.077,0.15,14.101c-3.921,6.024-9.759,11.998-9.759,11.998L55.995,253.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M45.875,237.699c0,0-1.03-3.618-7.537-7.242c-6.507-3.624-10.588-5.592-10.588-5.592 s-0.164,9.043,5.981,12.77c6.146,3.727,13.997,6.577,13.997,6.577L45.875,237.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M59.707,263.465c0,0-1.404-3.49-8.256-6.411c-6.852-2.92-11.117-4.449-11.117-4.449 s0.787,9.01,7.29,12.071c6.503,3.061,14.611,5.07,14.611,5.07L59.707,263.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M63.157,293.569c0,0-0.642-3.707-6.729-7.998c-6.088-4.291-9.938-6.679-9.938-6.679 s-1.119,8.975,4.598,13.33c5.717,4.356,13.224,8.019,13.224,8.019L63.157,293.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M64.503,300.831c0,0-1.162-3.578,2.221-10.214c3.382-6.636,5.673-10.544,5.673-10.544 s5.177,7.416,2.153,13.936c-3.025,6.52-7.955,13.263-7.955,13.263L64.503,300.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M74.891,330.731c0,0,0.429-3.737,6.262-8.369c5.833-4.632,9.54-7.235,9.54-7.235 s1.63,8.897-3.83,13.571c-5.459,4.674-12.745,8.761-12.745,8.761L74.891,330.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M73.353,321.508c0,0-0.642-3.707-6.73-7.998c-6.088-4.291-9.937-6.679-9.937-6.679 s-1.119,8.975,4.598,13.331c5.717,4.355,13.224,8.019,13.224,8.019L73.353,321.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6FF00"
    },
    d: "M73.272,341.658c0,0,0.318-3.749-4.485-9.442c-4.803-5.693-7.922-8.978-7.922-8.978 s-3.356,8.399,1.072,14.06c4.428,5.662,10.762,11.107,10.762,11.107L73.272,341.658z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M43.821,230.574c0.99,3.909,2.15,7.931,3.414,11.264c3.886,10.244,10.199,16.194,13.908,25.413 c3.709,9.218-0.045,22.572,3.66,34.595c3.705,12.023,9.676,18.033,9.729,26.475c0.053,8.442-3.28,31.91-3.28,31.91"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 46.353,
    y1: 240.154,
    x2: 40.017,
    y2: 236.83
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 45.237,
    y1: 235.257,
    x2: 46.857,
    y2: 230.689
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M60.756,266.864c0,0-5.29-2.701-10.71-5.38"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M57.15,259.961c0,0,2.577-8.324,6.121-14.163"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M63.886,298.875c0,0-4.88-6.523-12.334-11.663"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M65.697,303.92c0,0,1.373-5.998,3.406-10.503c2.034-4.505,2.334-5.092,2.334-5.092"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M74.245,334.724c0,0,4.199-5.147,6.813-7.073c2.613-1.926,4.424-3.847,4.424-3.847"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M74.533,328.32c0,0-2.699-4.431-5.693-7.798c-2.994-3.366-6.701-6.208-6.701-6.208"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M72.7,348.405c0,0-0.22-4.534-2.824-7.968c-2.604-3.434-5.671-7.994-6.919-9.787"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M100.261,400.656H62.567c-1.551,0-2.808-1.257-2.808-2.808l-5.414-41.711h54.137l-5.414,41.711 C103.068,399.399,101.811,400.656,100.261,400.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M108.011,363.199H54.345c-2.34,0-4.237-1.897-4.237-4.237l0,0c0-2.34,1.897-4.237,4.237-4.237 h53.666c2.34,0,4.237,1.897,4.237,4.237l0,0C112.248,361.302,110.351,363.199,108.011,363.199z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M382.01,365.983l16.597,26.739c2.115,3.408-0.336,7.813-4.346,7.813h-32.505h-43.488h42.088c4,0,6.452-4.384,4.359-7.792 l-16.066-26.164L382.01,365.983z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 382.01,365.983 348.649,366.579 354.827,376.64 388.624,376.64  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M293.179,371.94h135.96c1.608,0,2.912-1.304,2.912-2.912V255.11c0-1.608-1.303-2.912-2.912-2.912h-135.96 c-1.608,0-2.912,1.303-2.912,2.912v113.919C290.267,370.637,291.571,371.94,293.179,371.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M287.818,371.94h135.96c1.608,0,2.912-1.304,2.912-2.912V255.11c0-1.608-1.304-2.912-2.912-2.912h-135.96 c-1.608,0-2.912,1.303-2.912,2.912v113.919C284.906,370.637,286.21,371.94,287.818,371.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M289.672,252.199h132.252c2.632,0,4.766,2.134,4.766,4.766v93.529H284.906v-93.529 C284.906,254.332,287.04,252.199,289.672,252.199z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.863,
    y: 256.965,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 711.5953 600.9055)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 129.869,
    height: 86.977
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 248.421,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.921,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.42,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.92,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.419,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.919,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.418,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.918,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.417,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.917,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.416,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.916,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.415,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.915,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.414,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.914,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.413,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.913,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.412,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.912,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.411,
    y: 394.548,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 4.125,
    height: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.292,
    y: 396.122,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 119.247,
    height: 4.445
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.451,
    y: 396.122,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 29.088,
    height: 4.445
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M286.71,413.327v1.34h-0.64v-1.369c0-2.477-0.933-4.546-3.614-4.546 c-2.71,0-3.643,2.069-3.643,4.546v10.433c0,2.477,0.933,4.518,3.643,4.518c2.682,0,3.614-2.041,3.614-4.518v-4.633h-3.177v-0.583 h3.818v5.187c0,2.826-1.165,5.158-4.283,5.158c-3.09,0-4.255-2.332-4.255-5.158v-10.374c0-2.828,1.165-5.158,4.255-5.158 C285.546,408.168,286.71,410.499,286.71,413.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M290.673,423.905l-1.195,4.809h-0.583l4.925-20.429h0.904l5.041,20.429h-0.64l-1.195-4.809 H290.673z M290.789,423.322h7.023l-3.555-14.279L290.789,423.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M304.717,428.713v-19.787h-4.429v-0.613h9.529v0.613h-4.458v19.787H304.717z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M318.238,418.077v0.582h-6.002v9.443h7.14v0.612h-7.781v-20.4h7.781v0.613h-7.14v9.151H318.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M326.163,428.713h-0.933l-3.672-20.4h0.642l3.554,19.526l3.527-19.409h0.787l3.323,19.292 l3.438-19.409h0.583l-3.614,20.4h-0.845l-3.292-18.884L326.163,428.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M340.907,423.905l-1.195,4.809h-0.583l4.926-20.429h0.903L350,428.713h-0.642l-1.195-4.809 H340.907z M341.024,423.322h7.023l-3.555-14.279L341.024,423.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M355.448,420.466l-4.75-12.153h0.64l4.459,11.278l4.458-11.278h0.67l-4.838,12.153v8.247h-0.64 V420.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M371.445,428.713v-19.787h-4.43v-0.613h9.53v0.613h-4.459v19.787H371.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M378.962,408.313v20.4h-0.642v-20.4H378.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M387.645,428.655h-0.728l-5.042-19.379v19.438h-0.583v-20.4h0.991l5.012,19.352l5.012-19.352 h0.991v20.4h-0.641v-19.438L387.645,428.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M402.273,418.077v0.582h-6.003v9.443h7.14v0.612h-7.781v-20.4h7.781v0.613h-7.14v9.151H402.273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M405.652,413.327c0-2.856,1.223-5.158,4.313-5.158c3.147,0,4.371,2.302,4.371,5.158v10.374 c0,2.856-1.224,5.158-4.371,5.158c-3.09,0-4.313-2.302-4.313-5.158V413.327z M406.293,423.73c0,2.507,0.962,4.547,3.673,4.547 c2.739,0,3.73-2.04,3.73-4.547v-10.433c0-2.506-0.991-4.546-3.73-4.546c-2.71,0-3.673,2.04-3.673,4.546V423.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M417.249,423.701c0,2.448,0.875,4.575,3.584,4.575c2.71,0,3.585-2.127,3.585-4.575v-15.388h0.612 v15.359c0,2.798-1.107,5.187-4.197,5.187c-3.117,0-4.225-2.389-4.225-5.187v-15.359h0.641V423.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M431.149,428.713v-19.787h-4.429v-0.613h9.529v0.613h-4.458v19.787H431.149z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M316.534,313.064v5.656c0,4.35,1.915,5.917,4.961,5.917c3.045,0,4.96-1.567,4.96-5.917V305.32 c0-4.35-1.915-6.004-4.96-6.004c-3.046,0-4.961,1.654-4.961,6.004v1.827h-9.048l1.74-35.327h25.234v8.701h-16.621l-0.783,14.531 c1.741-2.871,4.525-4.438,8.354-4.438c7.048,0,10.616,4.959,10.616,13.922v13.574c0,9.745-4.873,15.314-14.27,15.314 c-9.398,0-14.27-5.569-14.27-15.314v-5.047H316.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M341.592,286.439c0-9.746,5.133-15.315,14.531-15.315c9.398,0,14.531,5.569,14.531,15.315v31.673 c0,9.745-5.133,15.314-14.531,15.314c-9.398,0-14.531-5.569-14.531-15.314V286.439z M351.164,318.721 c0,4.35,1.915,6.004,4.959,6.004c3.046,0,4.96-1.654,4.96-6.004v-32.891c0-4.351-1.913-6.004-4.96-6.004 c-3.045,0-4.959,1.652-4.959,6.004V318.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M374.566,312.977l17.404-41.157h10.441v41.157h4.525v8.702h-4.525v11.05h-9.397v-11.05h-18.448 V312.977z M393.014,312.977v-22.884l-9.659,22.884H393.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M337.877,236.42v0.582h-6.003v9.443h7.141v0.612h-7.781v-20.4h7.781v0.613h-7.141v9.151H337.877z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M345.337,226.656c3.03,0,4.196,1.778,4.196,4.575v1.836c0,2.507-0.991,3.876-3.235,4.284 c2.273,0.35,3.235,1.835,3.235,4.08v3.205c0,0.788,0.087,1.778,0.554,2.419h-0.7c-0.407-0.642-0.496-1.544-0.496-2.419v-3.205 c0-3.002-1.806-3.789-4.458-3.789h-2.507v9.413h-0.641v-20.4H345.337z M344.433,237.032c2.827,0,4.458-0.729,4.458-3.876v-1.865 c0-2.477-0.961-4.021-3.584-4.021h-3.381v9.762H344.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M356.409,226.656c3.03,0,4.196,1.778,4.196,4.575v1.836c0,2.507-0.991,3.876-3.235,4.284 c2.273,0.35,3.235,1.835,3.235,4.08v3.205c0,0.788,0.087,1.778,0.554,2.419h-0.7c-0.408-0.642-0.496-1.544-0.496-2.419v-3.205 c0-3.002-1.806-3.789-4.458-3.789h-2.507v9.413h-0.64v-20.4H356.409z M355.505,237.032c2.826,0,4.458-0.729,4.458-3.876v-1.865 c0-2.477-0.961-4.021-3.584-4.021h-3.381v9.762H355.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M363.401,231.669c0-2.855,1.225-5.157,4.313-5.157c3.147,0,4.372,2.302,4.372,5.157v10.375 c0,2.856-1.225,5.158-4.372,5.158c-3.089,0-4.313-2.302-4.313-5.158V231.669z M364.043,242.073c0,2.507,0.961,4.547,3.672,4.547 c2.74,0,3.73-2.04,3.73-4.547V231.64c0-2.506-0.99-4.546-3.73-4.546c-2.71,0-3.672,2.04-3.672,4.546V242.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M378.437,226.656c3.03,0,4.196,1.778,4.196,4.575v1.836c0,2.507-0.991,3.876-3.235,4.284 c2.273,0.35,3.235,1.835,3.235,4.08v3.205c0,0.788,0.087,1.778,0.554,2.419h-0.7c-0.407-0.642-0.496-1.544-0.496-2.419v-3.205 c0-3.002-1.806-3.789-4.458-3.789h-2.507v9.413h-0.64v-20.4H378.437z M377.534,237.032c2.826,0,4.458-0.729,4.458-3.876v-1.865 c0-2.477-0.961-4.021-3.584-4.021h-3.381v9.762H377.534z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M192.555,247.645c0,0,5.11-8.827,6.969-5.11c1.858,3.716,1.394,11.614-1.394,15.33c-2.787,3.717-3.717,5.575-5.11,2.787 C191.625,257.866,192.555,247.645,192.555,247.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M131.697,254.614c0,0-6.039-7.433-7.433-2.323c-1.394,5.11,5.575,11.614,7.433,12.543c1.858,0.929,4.646,0.465,4.646,0.465 L131.697,254.614z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M153.944,286.513c0,0-65.296,19.775-65.296,23.507s-1.866,76.863-0.373,80.967 c1.493,4.104,13.805,8.209,20.522,8.209v1.493h143.278l-7.089-39.551c0,0,40.297-1.492,41.043-4.477 c0.746-2.985-35.382-62.669-38.74-64.535c-3.358-1.866-54.54-7.477-60.51-7.477 C180.808,284.647,168.122,282.035,153.944,286.513z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible",
      fill: "#C6FF00"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000098209654504499324810000006194601210146573981_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      clipPath: "url(#XMLID_00000098209654504499324810000006194601210146573981_)"
    },
    d: "M212.329,400.687 c-90.474-33.247-86.429-50.185-86.429-50.185l-30.02,45.849c4.255,1.689,9.364,2.843,12.917,2.843v1.493H212.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      clipPath: "url(#XMLID_00000098209654504499324810000006194601210146573981_)"
    },
    d: "M188.932,304.441 c0,0,30.708-1.616,50.911-16.162l-56.567-7.273L188.932,304.441z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 243.722,
    y1: 342.761,
    x2: 233.024,
    y2: 310.667
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M101.083,311.38c0,0,17.83,9.985,23.535,33.52"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M100.961,355.913c0,0-11.94,7.836-14.552,9.701c-2.612,1.866-3.358,21.641-0.746,27.238c2.612,5.597,13.805,8.209,21.268,4.477 c7.462-3.731,10.821-21.268,8.209-30.223C112.527,358.152,100.961,355.913,100.961,355.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M144.616,290.244c0,0,1.119,17.91,4.477,29.85c3.358,11.94,9.701,27.611,9.701,27.611l21.268-16.79l28.73,7.089 c0,0-5.597-29.477-9.701-39.177c-4.104-9.701-12.313-17.537-12.313-17.537S155.436,277.185,144.616,290.244z"
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    d: "M148.72,287.259c0,0,5.224,13.059,10.82,24.253c5.597,11.194,19.029,26.865,22.387,23.507 c3.358-3.358,6.716-29.477,6.716-35.446s0-17.91,0-17.91s-10.447,8.582-18.656,8.582S148.72,287.259,148.72,287.259z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000127009502009063340170000017038308483665642421_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000127009502009063340170000017038308483665642421_)",
      fill: "#C6FF00"
    },
    d: "M188.644,281.662 c0,0-10.447,8.582-18.656,8.582c-8.209,0-21.268-2.985-21.268-2.985s2.652,6.628,6.2,14.487 c5.505,3.483,12.975,6.313,21.833,4.904c4.675-0.744,8.6-3.294,11.886-6.812c0.001-0.088,0.004-0.186,0.004-0.266 C188.644,293.602,188.644,281.662,188.644,281.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      clipPath: "url(#XMLID_00000127009502009063340170000017038308483665642421_)",
      fill: "#FFFFFF"
    },
    d: " M188.644,281.662c0,0-10.447,8.582-18.656,8.582c-8.209,0-21.268-2.985-21.268-2.985s2.652,6.628,6.2,14.487 c5.505,3.483,12.975,6.313,21.833,4.904c4.675-0.744,8.6-3.294,11.886-6.812c0.001-0.088,0.004-0.186,0.004-0.266 C188.644,293.602,188.644,281.662,188.644,281.662z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M130.303,250.897c0,0,7.898,26.015,13.008,32.984c5.11,6.968,19.047,13.937,29.267,13.472 c10.22-0.465,18.582-10.685,20.441-20.905c1.858-10.221,0.465-33.449,0.465-33.449s-1.858-10.22-9.756-23.693 c-7.897-13.472-47.85-2.323-52.031,7.898C127.516,237.425,130.303,250.897,130.303,250.897z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M161.894,271.338c0,0,4.646,6.504,10.22-0.464"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M147.492,261.117c0,0,4.181-3.716,9.756,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M173.508,258.33c0,0,1.858-3.717,8.827-3.717"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2.355,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M145.169,253.685c0,0,2.787-4.646,12.078-5.575"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2.355,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M171.138,252.264c0,0,4.521-9.39,12.59-6.477"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M172.578,282.023c0,1.283-1.144,2.323-2.555,2.323s-2.555-1.04-2.555-2.323 c0-1.283,1.144-2.323,2.555-2.323S172.578,280.74,172.578,282.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M157.526,262.514c0,0.776-0.629,1.406-1.406,1.406c-0.776,0-1.406-0.629-1.406-1.406 c0-0.777,0.63-1.406,1.406-1.406C156.897,261.108,157.526,261.737,157.526,262.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M181.982,257.257c0,0.776-0.629,1.406-1.406,1.406c-0.776,0-1.406-0.63-1.406-1.406 c0-0.777,0.629-1.406,1.406-1.406C181.352,255.851,181.982,256.48,181.982,257.257z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M152.138,194.685c0,0-6.968,0-16.26,0c-9.291,0-21.37,24.622-20.905,36.236c0.465,11.614,10.685,19.047,13.472,20.441 c2.787,1.394,7.898,3.716,7.898,2.323c0-1.394,5.575-12.543,5.575-12.543s-1.394,6.504,2.323,6.504 c3.717,0,15.331-12.079,15.331-12.079s0.465,9.756,4.181,9.756c3.716,0,11.614-14.401,11.614-14.401l8.362,9.291l2.787-5.575 c0,0,3.252,13.008,6.039,13.008c2.787,0,5.11-6.504,6.504-13.008c1.394-6.504,4.181-17.189-0.464-26.945 c-4.646-9.756-18.118-18.582-29.267-18.582C158.177,189.111,152.138,194.685,152.138,194.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#6B6B6B",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M146.391,198.401c0,0-11.441,1.32-16.721,4.84c-5.28,3.52-7.041,7.921-7.041,7.921l11.441-5.28c0,0-7.481,5.72-8.361,8.361 c-0.88,2.64-1.76,8.361-1.76,8.361l7.041-2.2c0,0-2.907,2.439-2.64,4.84c0.267,2.402,1.32,7.921,1.32,7.921l8.361-7.921l2.2,5.721 l7.041-5.721l0.44,4.4l4.84-6.6l3.96,3.96l2.64-4.84c0,0,2.2,2.2,3.08-3.08c0.88-5.28,1.32-7.481,1.32-7.481l4.84,5.721 l1.76,7.481l1.32-7.921l3.96,3.52l1.32-6.6l4.84,2.64l1.76-6.16l10.561,3.52c0,0-3.08-11.001-5.72-14.081 c-2.64-3.08-15.401-4.4-15.401-4.4l-1.32-2.2c0,0-14.961,3.08-16.721,3.96c-1.76,0.88-3.96,3.08-3.96,3.08"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M118.87,277.931c0,0-2.612-2.612-2.612-6.716c0-4.104,4.477-13.059,5.597-13.059s3.358,2.239,3.358,2.239 s-1.866,8.955-2.612,12.313C121.855,276.065,118.87,277.931,118.87,277.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M121.482,281.662c0,0-3.731-4.477-3.731-6.343s5.97-14.925,7.462-14.925c1.493,0,5.97,1.866,7.089,2.612 c1.119,0.746,0.746,4.477,0.746,7.089c0,2.612-6.716,14.179-6.716,14.179L121.482,281.662z"
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M129.318,262.26c0,0-9.328,16.79-7.835,19.402c1.493,2.612,16.417,18.656,16.417,18.656 s-42.536,63.43-46.64,69.773c-4.104,6.343-4.851,15.671-2.985,20.895s13.059,10.074,20.895,9.701 c7.836-0.373,13.806-10.074,16.044-19.029c2.239-8.955,22.387-74.624,24.253-79.848s4.477-9.328,1.866-11.94 c-2.612-2.612-12.686-12.313-12.686-12.313s2.985-2.612,2.612-5.597C140.884,268.976,134.541,263.006,129.318,262.26z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_3_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000008121939224092682860000004932897632668723363_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000008121939224092682860000004932897632668723363_)",
      fill: "#C6FF00"
    },
    d: "M125.213,381.658 c2.239-8.955,22.387-74.624,24.253-79.848c1.866-5.224,4.477-9.328,1.866-11.94c-2.353-2.353-10.738-10.436-12.382-12.02 l-0.064,0.014c1.47,1.907,9.183,12.249,8.386,18.224c-0.88,6.6-34.763,86.247-39.163,91.527 c-3.364,4.036-12.377,6.528-16.44,7.479c4.375,3.378,11.814,5.864,17.501,5.593 C117.005,400.314,122.975,390.613,125.213,381.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      clipPath: "url(#XMLID_00000008121939224092682860000004932897632668723363_)",
      fill: "#FFFFFF"
    },
    d: " M125.213,381.658c2.239-8.955,22.387-74.624,24.253-79.848c1.866-5.224,4.477-9.328,1.866-11.94 c-2.353-2.353-10.738-10.436-12.382-12.02l-0.064,0.014c1.47,1.907,9.183,12.249,8.386,18.224 c-0.88,6.6-34.763,86.247-39.163,91.527c-3.364,4.036-12.377,6.528-16.44,7.479c4.375,3.378,11.814,5.864,17.501,5.593 C117.005,400.314,122.975,390.613,125.213,381.658z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_3_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M134.915,270.469l-1.866,4.477l5.597,2.612c0,0,0.085,0.107,0.239,0.307"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M246.104,339.496c0,0,3.358-5.597,7.462-7.089c4.104-1.492,20.149-2.985,26.492-0.746c6.343,2.239,10.074,10.447,11.194,14.925 c1.119,4.478,0.746,10.82-2.985,14.178c-3.731,3.358-8.582,2.612-13.806,1.119c-5.224-1.492-15.671-7.462-21.268-10.82 C247.597,347.704,246.477,341.734,246.104,339.496z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M193.867,333.153c0,0-29.476,24.253-33.581,26.491c-4.104,2.239-2.239,6.343-0.746,7.836 c1.493,1.492,11.194,10.447,15.671,13.432c4.477,2.985,10.821-2.239,12.313-2.985c1.493-0.746-0.373-4.104-0.373-4.104 s11.567-6.343,13.432-12.313s2.239-14.178,2.239-14.178s47.013,19.029,58.207,23.133c11.194,4.104,18.283,4.477,23.507-0.746 c5.224-5.224,5.597-16.044,2.985-21.641c-2.612-5.597-19.029-10.82-26.491-10.82c-7.463,0-60.445-6.343-63.804-5.224 C193.867,333.153,193.867,333.153,193.867,333.153z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000123406083992796797200000009507811728407286963_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#XMLID_00000123406083992796797200000009507811728407286963_)",
      fill: "#C6FF00"
    },
    d: "M284.536,369.718 c1.839-1.839,3.066-4.377,3.784-7.132c-19.634-1.211-77.21-22.991-82.964-23.374c-6.6-0.44-7.48,9.681-14.081,18.041 s-10.561,10.561-16.281,11.441c-3.903,0.6-4.527,5.499-4.531,8.553c1.797,1.494,3.484,2.821,4.749,3.664 c4.477,2.985,10.821-2.239,12.313-2.985c1.493-0.746-0.373-4.104-0.373-4.104s11.567-6.343,13.432-12.313 s2.239-14.178,2.239-14.178s47.013,19.029,58.207,23.133C272.223,374.569,279.312,374.942,284.536,369.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      clipPath: "url(#XMLID_00000123406083992796797200000009507811728407286963_)",
      fill: "#FFFFFF"
    },
    d: " M284.536,369.718c1.839-1.839,3.066-4.377,3.784-7.132c-19.634-1.211-77.21-22.991-82.964-23.374 c-6.6-0.44-7.48,9.681-14.081,18.041s-10.561,10.561-16.281,11.441c-3.903,0.6-4.527,5.499-4.531,8.553 c1.797,1.494,3.484,2.821,4.749,3.664c4.477,2.985,10.821-2.239,12.313-2.985c1.493-0.746-0.373-4.104-0.373-4.104 s11.567-6.343,13.432-12.313s2.239-14.178,2.239-14.178s47.013,19.029,58.207,23.133 C272.223,374.569,279.312,374.942,284.536,369.718z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 187.151,
    y1: 373.823,
    x2: 182.301,
    y2: 376.061
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 200.957,340.988 202.822,347.331 208.046,349.943 205.061,337.63  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M209.165,335.578c0,3.812-3.926,6.903-8.768,6.903c-4.842,0-8.768-3.091-8.768-6.903c0-3.812,3.926-6.903,8.768-6.903 C205.24,328.675,209.165,331.766,209.165,335.578z"
  })))), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.1775,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 40.61,
    y1: 400.656,
    x2: 443.332,
    y2: 400.656
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOut);
export default __webpack_public_path__ + "static/media/timeOut.64cb376903c37121659bafd64c435961.svg";
export { ForwardRef as ReactComponent };